import React from "react";
import { Box, Typography } from "@mui/material";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomButton from "../../../../components/CustomButton";
import { AppColors } from "../../../../util/AppColors";
import PropTypes from "prop-types";

const DispenseConfirmationModal = ({ open, onClose, record, onConfirm }) => {
  if (!record) return null;

  // Internal data mapping
  const patientName = record.patientName || "Patient";
  const itemCount = record.dispenseCount || 0;

  // Determine products list to display
  let products = [];
  if (record.id === 1) {
    products = [
      { name: "VEGGIEDENT", quantity: 1 },
      { name: "Amoxicillin 250mg", quantity: 14 }
    ];
  } else if (record.itemsList) {
    products = record.itemsList
      .filter((item) => item.action === "Dispense" || !item.action)
      .map((item) => ({
        name: item.name,
        quantity: item.qty || 1
      }));
  }

  // Fallback if no products list could be determined
  if (products.length === 0 && itemCount > 0) {
    products = [{ name: "Prescribed items", quantity: itemCount }];
  }

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      header="Dispense medications"
      modal
      modalWidth="35"
      headerShown
      headerBlack
      headerBold
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5, px: 1, pb: 1 }}>
        <Typography
          variant="body1"
          sx={{
            fontFamily: "Montserrat",
            fontSize: "14px",
            color: AppColors.black,
            fontWeight: 500
          }}
        >
          Dispense {itemCount} item(s) for <strong>{patientName}</strong>?
        </Typography>

        {products.length > 0 && (
          <Box
            sx={{
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              padding: "16px",
              border: "1px solid #e2e2e2",
              display: "flex",
              flexDirection: "column",
              gap: 1
            }}
          >
            <Typography
              sx={{
                fontFamily: "Montserrat",
                fontSize: "13px",
                fontWeight: "bold",
                color: AppColors.gray3,
                textTransform: "uppercase",
                mb: 0.5
              }}
            >
              Products:
            </Typography>
            {products.map((prod, index) => (
              <Typography
                key={index}
                sx={{
                  fontFamily: "Montserrat",
                  fontSize: "14px",
                  color: AppColors.black,
                  fontWeight: 500
                }}
              >
                {prod.name} ({prod.quantity})
              </Typography>
            ))}
          </Box>
        )}

        {/* Footer actions aligned exactly as other modals */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 1 }}>
          <Box sx={{ width: "100px" }}>
            <CustomButton
              text="Cancel"
              smallBtn
              whiteBtn
              onClick={onClose}
            />
          </Box>
          <Box sx={{ width: "100px" }}>
            <CustomButton
              text="Confirm"
              smallBtn
              onClick={() => {
                if (onConfirm) onConfirm(record);
                onClose();
              }}
            />
          </Box>
        </Box>
      </Box>
    </CustomModal>
  );
};

DispenseConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  record: PropTypes.object,
  onConfirm: PropTypes.func
};

export default DispenseConfirmationModal;
